export class EmployeeConnectionInfoRequest {
    employeeNumber: string;
    locale: string;
    constructor(employeeNumber: string, locale: string) {
        this.employeeNumber = employeeNumber;
        this.locale = locale;
    }
}